import { useMemo } from 'react';

import camelcaseKeys from 'camelcase-keys';
import { useRouter } from 'next/router';

const useQueryParams = <T = Record<string, string | void>>(
  initialState: Partial<T> = {}
): T | undefined => {
  const { query, isReady } = useRouter();

  const queryParams = useMemo(() => {
    if (!isReady) return undefined;

    const obj = query;

    return {
      ...initialState,
      ...camelcaseKeys(obj),
    } as T;
  }, [isReady, query, initialState]);

  return queryParams;
};

export default useQueryParams;
